// Map palettes (§12.2). `fog` is the sky-bottom color (§12.5); `light` the key light (§12.3).
import { MapId } from '@shared/ids';
import type { MapPalette } from './MapView';

const KEY_LIGHT = '#FFF2DE';

const LOBBY: MapPalette = { base: '#D9A86C', accent1: '#FFF1C9', accent2: '#FF5A4E', void: '#BDB2FF', skyTop: '#FFD6A5', skyBottom: '#BDB2FF', fog: '#BDB2FF', light: KEY_LIGHT };

export const MAP_PALETTES: Readonly<Record<MapId, Readonly<MapPalette>>> = {
  [MapId.LOBBY]: LOBBY,
  [MapId.PODIUM]: LOBBY,
  [MapId.TEACUP]: { base: '#FFF4E6', accent1: '#9DE0C8', accent2: '#E8B64C', void: '#8A4B22', skyTop: '#FFE3C8', skyBottom: '#C8B6FF', fog: '#C8B6FF', light: KEY_LIGHT },
  [MapId.PINBALL]: { base: '#1B1440', accent1: '#FF3EC8', accent2: '#2FF3FF', void: '#0B0820', skyTop: '#120B2E', skyBottom: '#3A1C6E', fog: '#3A1C6E', light: KEY_LIGHT },
  [MapId.CAKE]: { base: '#FFB3C7', accent1: '#FFF1E0', accent2: '#F2C28B', void: '#F7F7FF', skyTop: '#FFE1EC', skyBottom: '#B9E6FF', fog: '#B9E6FF', light: KEY_LIGHT },
  [MapId.SPIN]: { base: '#F4FBFF', accent1: '#4FD1C5', accent2: '#9AA9B8', void: '#FFFFFF', skyTop: '#CFF4FF', skyBottom: '#8FB8FF', fog: '#8FB8FF', light: KEY_LIGHT },
};
